<div class="tab-pane" id="tab-nrt" role="tabpanel" aria-labelledby="tab-nrt-tab">
  <h3>Download de Arquivos</h3>

  <form [formGroup]="form">
    <!-- Campos do formulário para Cliente e Operação -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Cliente</mat-label>
      <mat-select formControlName="clienteSelecionado" placeholder="Selecione um cliente" (selectionChange)="selecionarCliente()" required>
        <mat-option *ngFor="let cliente of listaClientes" [value]="cliente.clienteId">
          {{ cliente.nome }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('clienteSelecionado')?.hasError('required')">Cliente é obrigatório</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Operação</mat-label>
      <mat-select formControlName="operacaoSelecionada" placeholder="Selecione uma operação" [disabled]="!clienteSelecionado" required>
        <mat-option *ngFor="let operacao of listaOperacao" [value]="operacao.operacao">
          {{ operacao.operacao }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('operacaoSelecionada')?.hasError('required')">Operação é obrigatória</mat-error>
    </mat-form-field>

    <div style="display: flex; justify-content: center; gap: 16px; margin-top: 16px;">
      <button mat-raised-button color="primary" type="button" (click)="listaDownload()" [disabled]="!form.valid || carregando">
        <mat-icon>search</mat-icon>
        <span *ngIf="!carregando">Pesquisar</span>
        <mat-spinner *ngIf="carregando" diameter="20"></mat-spinner>
      </button>

      <button mat-raised-button color="primary" type="button" (click)="limparCampos()" [disabled]="carregando">
        <mat-icon>delete_sweep</mat-icon>
        Limpar
      </button>
    </div>
    <br><br>
  </form>

  <div *ngIf="listaArquivos.length > 0" style="border: 1px solid #ccc; padding: 50px; border-radius: 8px;">
    <h3>Arquivos disponíveis:</h3>
  
    <!-- Cabeçalhos para Nome do Arquivo e Data de Criação -->
    <div style="display: grid; grid-template-columns: 1fr 1fr auto; gap: 10px; font-weight: bold; margin-bottom: 10px;">
      <span>Nome do Arquivo</span>
      <span>Data de Criação</span>
      <span>Ações</span>
    </div>
  
    <mat-list>
      <mat-list-item *ngFor="let arquivo of listaArquivos; let i = index" [ngClass]="{ 'linha-par': i % 2 === 0, 'linha-impar': i % 2 !== 0 }">
        <!-- Exibe as informações de cada arquivo -->
        <div style="display: grid; grid-template-columns: 1fr 1fr auto; gap: 10px; width: 100%; align-items: center;">
          <span>{{ arquivo.nome }}</span>
          <span>{{ arquivo.dataCriacao | date: 'dd/MM/yyyy HH:mm' }}</span> <!-- Exibe a data formatada -->
          <button mat-icon-button color="black" type="button" (click)="baixarArquivo(arquivo.nome)">
            <mat-icon>cloud_download</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
  
  
 
  <div *ngIf="!carregando && listaArquivos.length === 0 && form.valid" style="margin-top: 24px; color: #999;">
    <p>Nenhum arquivo encontrado para os filtros selecionados.</p>
  </div>
</div>
